import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[siren]',
    standalone: false
})
export class SirenDirective {
	inputElement: HTMLInputElement;
	@Input() siren: boolean = false;

	constructor(private el: ElementRef) {
		this.inputElement = el.nativeElement;
	}

	@HostListener('blur', ['$event']) onBlur($event): void {
		if (!this.siren) {
    		return;
  		}
		const value: string = this.inputElement.value;
		if (!value) {
			return;
		}

		// Convert the number to a string
		const strNumber: string = value.toString().split('').reverse().join('');

		// Define the pattern to match groups of three digits
		const pattern: RegExp = /(.{3})(?=(\d{3})+(?!\d))/g;

		// Use the pattern to insert spaces between groups
		const formattedNumber: string = strNumber.replace(pattern, '$1 ');
		$event.target.value = formattedNumber.split('').reverse().join('');
	}

	@HostListener('focus', ['$event']) onFocus($event) {
		const regex = /^[0-9\s]+$/;
		if (regex.test($event.target.value)) {
			$event.target.value = this.inputElement.value?.replace(/\s/g, '');
		}

		if ($event.target.value.includes('RCS')) {
			$event.target.value = this.inputElement.value?.replace(/ {2}/g, ' ');
		}
	}

	@HostListener('keydown', ['$event']) onKeydown($event): void {
		if ($event.key == 'Enter') {
			const value: string = this.inputElement.value;
			if (!value) {
				return;
			}

			//$event.target.value = value.split(' ').join('').replace(/(.{4})/g, "$1 ");
		}
	}
}
